export default "__VITE_ASSET__BX0oGIR8__"